<template>
  <div class="n-emoji-picker">
    <div
      class="n-emoji-picker__button-container"
      :class="{ 'n-emoji-picker__button-container--open': emojiPickerOpen }"
      :style="{ color: accentColour }"
    >
      <n-button icon="emoji" variant="action" class="n-message-composer__emoji-button" @click="toggleOpen"></n-button>
    </div>
    <div class="n-emoji-picker__overlay" @click="toggleOpen" v-if="emojiPickerOpen"></div>
    <Picker
      v-if="emojiPickerOpen"
      :emoji-size="21"
      :perLine="10"
      :native="true"
      :showPreview="false"
      :data="ei"
      @select="insertEmoji"
      class="emoji-picker"
    ></Picker>
    <div class="arrow-down" v-if="emojiPickerOpen">
      <div class="inner-arrow"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src';
import emojiList from '../../../data/emoji-list';
import NButton from '../../control/button/button.vue';

defineOptions({
  name: 'n-emoji-picker',
});

defineProps({
  accentColour: {
    type: String,
    default: '#062b80',
  },
});

const emit = defineEmits<{
  (e: 'emojiSelect', emoji: any): void;
}>();

const emojiPickerOpen = ref(false);

const ei = new EmojiIndex(emojiList, {
  recentLength: 8,
  exclude: ['flags', 'symbols'],
});

function toggleOpen() {
  emojiPickerOpen.value = !emojiPickerOpen.value;
}

function insertEmoji(emoji: any) {
  toggleOpen();
  emit('emojiSelect', emoji);
}
</script>

<style lang="scss" scoped>
.n-emoji-picker {
  position: relative;
  display: flex;
  align-items: center;
  &__button-container {
    &--open {
      :deep(.btn.btn--action) {
        color: currentColor;
      }
    }
  }
  .n-emoji-picker__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: default;
  }
}
:deep(.emoji-mart) {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
  color: rgb(33, 33, 33);
  font-size: 1em;
  height: 300px;
  width: 400px;
  padding-bottom: 5px;
  position: absolute;
  bottom: 40px;
  left: -280px;
  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.2);
  }
  h3.emoji-mart-category-label {
    font-size: 1em;
    margin: 0;
  }
  .emoji-mart-search {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE1LjUgMTRoLS43OWwtLjI4LS4yN0E2LjQ3MSA2LjQ3MSAwIDAgMCAxNiA5LjUgNi41IDYuNSAwIDEgMCA5LjUgMTZjMS42MSAwIDMuMDktLjU5IDQuMjMtMS41N2wuMjcuMjh2Ljc5bDUgNC45OUwyMC40OSAxOWwtNC45OS01em0tNiAwQzcuMDEgMTQgNSAxMS45OSA1IDkuNVM3LjAxIDUgOS41IDUgMTQgNy4wMSAxNCA5LjUgMTEuOTkgMTQgOS41IDE0eiIvPjwvc3ZnPg==');
    font-weight: normal;
    font-size: 1em;
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: 15px 1px;
    padding-right: 0;
    padding-left: 0;

    input {
      opacity: 0.7;
      border: none;
      font-size: 1em;
      border-radius: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      margin-bottom: 5px;
      padding: 5px 0 10px 46px;
    }
  }
}
:deep(.emoji-mart-scroll) {
  scrollbar-color: #eee transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #eee;
    border-radius: 1em;
    border: 3px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    height: 40px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #ccc;
    border: 3px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }
}
.arrow-down {
  position: absolute;
  width: 0;
  height: 0;

  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #dadada;

  left: 5px;
  bottom: 30px;
  z-index: 9999;

  .inner-arrow {
    position: relative;
    width: 0;
    height: 0;
    bottom: 11.5px;
    right: 10px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid rgb(255, 255, 255);
  }
}
</style>
